import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  private categoriesSource = new BehaviorSubject<any[]>([]);
  private idSource = new BehaviorSubject<number | null>(null);

  categories$ = this.categoriesSource.asObservable();
  currentId$ = this.idSource.asObservable();

  getCategories(id?: number, language?: string): Observable<any> {
    let url = this.apiData.apiURL + `api/${this.client}/categories/de`;
    if (language) {
      url = this.apiData.apiURL + `api/${this.client}/categories/` + language;
    }

    if (id) {
      url += '/' + id;
    }
    return this.http.get<any>(url);
  }

  updateCategories(categories: any[]) {
    this.categoriesSource.next(categories);
  }

  setId(id: number) {
    this.idSource.next(id);
  }
}
